import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SendGraveEmailDto } from '../models/send-grave-email.model';
import { environment } from '../../environments/environment';
import { GenericResponse } from '../core/models/pagination.model';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private apiUrl = `${environment.apiUrl}Email/`;

  constructor(private http: HttpClient) { }

  /**
   * Sends an email with grave suggestions or feedback
   * @param emailData The grave email data containing ID and additional message
   * @returns Observable of the API response
   */
  sendGraveEmail(emailData: SendGraveEmailDto): Observable<GenericResponse<any>> {
    return this.http.post<GenericResponse<any>>(`${this.apiUrl}SendGraveEmail`, emailData);
  }
}
